<template>
  <div class="content">
    <div class="title">会议通知</div>
    <div class="header-search">
      <el-input
        v-model="option.title"
        placeholder="输入关键字搜索…"
        class="input"
      >
        <template #prefix>
          <i class="el-input__icon el-icon-search"></i>
        </template>
      </el-input>
      <el-button @click="getNoticePageList" class="btn-search"
        ><img src="../../../content/img/search.png"
      /></el-button>
    </div>
    <div class="table">
      <div class="table-box">
        <div class="search-change">
          <div
            class="grid-content bg-purple"
            style="margin-bottom: 10px"
            @click="getNoticePageList"
          >
            <router-link to="/backIndex/publishNotice">
              <el-button type="primary" style="background-color: #3475e8">
                <i class="el-icon-plus"></i> 发布通知</el-button
              ></router-link
            >
          </div>
        </div>
        <div class="table-pagination">
          <el-table :data="tableData.models" height="538">
            <el-table-column prop="Tilte" label="标题" show-overflow-tooltip />
            <el-table-column label="内容" show-overflow-tooltip>
              <template #default="scope">
                <div
                  style="width: 50px"
                  v-if="
                    scope.row.AttachedFilePath != '' &&
                    scope.row.AttachedFilePath != null &&
                    scope.row.IsShowAttachedFile
                  "
                >
                  <img
                    src="../../../content/img/text.png"
                    style="height: 16px; width: 16px; line-height: 20px"
                    alt=""
                  />
                  <a
                    target="_blank"
                    :href="scope.row.AttachedFilePath"
                    style="color: rgb(0, 0, 0, 0.6)"
                    ><div
                      style="
                        display: inline;
                        float: right;
                        margin-top: -3px;
                        padding-top: -3px;
                      "
                    >
                      通知
                    </div></a
                  >
                </div>
                <div v-html="scope.row.Content" v-else></div>
              </template>
            </el-table-column>
            <el-table-column prop="PublishTime" label="公布时间" />
            <el-table-column label="操作">
              <template #default="scope">
                <span class="cursor blue" @click="edit(scope.row)">编辑</span>
                <span class="">&nbsp; |&nbsp; </span>
                <span class="cursor green" @click="deleteNotice(scope.row)"
                  >删除</span
                >
                <span class=""> &nbsp;| &nbsp;</span>
                <span
                  class="cursor green"
                  @click="review(scope.row)"
                  v-if="scope.row.Status == 1"
                  >关闭</span
                >
                <span class="cursor blue" @click="review(scope.row)" v-else
                  >开启</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="demo-pagination-block table-pagination-page">
            <el-pagination
              v-model:currentPage="option.PageIndex"
              :page-sizes="[10, 20, 50, 100]"
              v-model:page-size="option.PageSize"
              background
              layout=" total,sizes, prev, pager, next, jumper"
              :total="tableData.total"
              @size-change="getNoticePageList"
              @current-change="getNoticePageList"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { reactive, ref } from "vue";
import { GetNoticePageList, DeleteNotice,ChangeStatus } from "../../../http/notice";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import router from "../../../router";
export default {
  setup() {
    const searchImg = require("../../../content/img/search.png");
    const resetImg = require("../../../content/img/refresh.png");
    let url = ref("");
    let schoolInfo = reactive({
      model: {},
    });
    let annexPath = require("../../../content/img/text.png");
    let drawer = ref(false);
    let dialogVisible = ref(false);
    let addIcon = require("../../../content/img/12.png");
    let tableData = reactive({
      models: [],
      total: 0,
    });
    let data = {
      NoticeIds: [],
    };
    let option = reactive({
      title: "",
      PageIndex: 1,
      PageSize: 10,
      IsAsc: false,
      SortFields: ["CreateTime"],
    });
    const resetSearch = () => {
      option.title = "";
    };
    let loading;
    const deleteNotice = (row) => {
      ElMessageBox.confirm("你确认要删除吗?", "确认", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          loading = ElLoading.service({
            lock: true,
            text: "删除中······",
            background: "rgba(0, 0, 0, 0.7)",
          });
          data.NoticeIds = [];
          data.NoticeIds.push(row.Id);
          DeleteNotice(data).then((res) => {
            if (res.IsSuccess) {
              getNoticePageList();
              ElMessage({
                message: "删除成功",
                type: "success",
              });
              loading.close();
            } else {
              ElMessage.error(res.ErrorMessage);
              loading.close();
            }
          });
        })
        .catch(() => {});
    };

    const getNoticePageList = async () => {
      await GetNoticePageList(option).then((res) => {
        if (res.IsSuccess) {
          tableData.models = res.Models;
          tableData.total = res.TotalCount;
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };
    getNoticePageList();
    const review = (row) => {
      let statusData={
        NoticeId:row.Id,
        Status:row.Status==0?1:0
      }
      ChangeStatus(statusData).then(res=>{
        ElMessage({
          message:res.SuccessMessage,
          type:'success'
        })
        getNoticePageList();
      })
    };
    const edit = (row) => {
      router.push({
        path: "/backIndex/publishNotice",
        query: {
          notice: encodeURIComponent(JSON.stringify(row)),
        },
      });
    };
    return {
      searchImg,
      resetImg,
      option,
      tableData,
      resetSearch,
      drawer,
      schoolInfo,
      dialogVisible,
      url,
      annexPath,
      deleteNotice,
      addIcon,
      getNoticePageList,
      review,
      edit,
    };
  },
};
</script>
  <style lang="scss" scoped>
.content {
  margin-left: 10px;
}

.title {
  margin-top: 0px;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: var(--h-228-s-8-l-24);
}

.header-search {
  width: 265px;
  margin-top: 20px;
}

.input {
  width: 200px;
  margin-left: 15px;
}

.btn-search {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  float: right;
}
.table {
  margin-top: 20px;
  border-radius: 20px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.12);
  background-color: var(--h-0-s-0-l-100);
  width: 85%;
  min-width: 800px;
  height: 100%;
  max-height: 756px;
}
.table-box {
  padding-top: 10px;
  width: 90%;
  margin: 0 auto;
  .btn-refresh {
    cursor: pointer;
  }
  .text-balck {
    > span {
      color: black;
    }
  }
  .table-pagination-page {
    margin-top: 16px;
    padding-bottom: 20px;
  }
}
.info {
  width: 90%;
  margin: 0 auto;
  .info-title {
    margin-top: 30px;
  }
  .info-box {
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .info-text {
    margin-top: 20px;
    font-size: 13px;
  }
  .text {
    color: rgb(0, 0, 0, 0.8);
    font-size: 13px;
  }
  .info-btn {
    margin-top: 50px;
  }
  .bg-gray {
    background-color: #ececec;
    height: 1px;
    width: 100%;
  }
  .info-annex {
    > a {
      text-decoration: none;
      color: #409eff;
    }
  }
}
.blue {
  color: #409eff;
}
.green {
  color: #47b18a;
}
.cursor {
  cursor: pointer;
}
</style>
<style>
.table-pagination p {
  margin: 0 !important;
}
.table-pagination .el-table__row {
  height: 49px;
}
</style>